// extracted by mini-css-extract-plugin
export default {"anchorPlacement":"ModuleAnchor_anchorPlacement__CNj2o"};